import React, { FC } from 'react'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type AuthenticationIntroProps = {
  className?: string
  title: string
  subtitle: string
  text: string
  button: ActionButtonProps
}

const AuthenticationIntro: FC<AuthenticationIntroProps> = ({
  className,
  title,
  subtitle,
  text,
  button,
}) => {
  return (
    <SC.Container className={className}>
      <SC.Title>{title}</SC.Title>
      <SC.FieldTitle>{subtitle}</SC.FieldTitle>
      <SC.FieldDescription>{text}</SC.FieldDescription>
      <SC.Center>
        <SC.Button {...button} variant="secondary" />
      </SC.Center>
    </SC.Container>
  )
}

export default AuthenticationIntro
